import React from 'react';
import { components, DropdownIndicatorProps, GroupBase } from 'react-select';
import classNames from 'classnames';

import { Icon } from '../../Icon';

import styles from './MultiSelectComponents.module.scss';

function DropdownIndicator<T, IsMulti extends boolean, Group extends GroupBase<T>>(
  props: DropdownIndicatorProps<T, IsMulti, Group>,
): JSX.Element {
  return (
    <components.DropdownIndicator {...props}>
      <Icon icon="chevron-down"
            size={props.selectProps.indicatorSize}
            className={classNames(styles.dropdownIndicator, {
              [styles.rotated]: Boolean(props.selectProps.menuIsOpen),
            })} />
    </components.DropdownIndicator>
  );
}

export default DropdownIndicator;
